const loginPages = {
  bankId: '/',
  pickOrg: 'velg-organisasjon/*',
  accountantLogin: 'regnskapsforer'
};
export const loginPagesPrefix = '/logg-inn';
export const bankPages = {
  transactions: '/',
  employees: 'brukere',
  addEmployee: 'brukere/legg-til',
  newEmployee: 'brukere/ny',
  addCoFounder: 'brukere/ny/:fid',
  employeeCreated: 'brukere/ny/ferdig',
  addAccountant: 'brukere/regnskapsforer',
  confirmInvitation: 'brukere/:fid/godkjenn',
  invitationDone: 'brukere/:fid/ferdig',
  invitationRejected: 'brukere/avvist',
  singleEmployee: 'brukere/:fid',
  singleEmployeeModified: 'brukere/:fid/endret',
  payments: 'betaling',
  approvedPaymentsList: 'betaling/godkjente',
  newPayment: 'betaling/ny',
  paymentDetails: 'betaling/:fid',
  salaryPaymentDetails: 'betaling/lonn/:fid',
  editPayment: 'betaling/:fid/endre',
  transferToTaxAccount: 'betaling/forskuddstrekk',
  chooseCreditor: 'betaling/velg-mottaker',
  internationalPayments: 'betaling/utland',
  salary: 'betaling/lonn',
  accounting: 'regnskap',
  accountingArchive: 'regnskap/arkiv',
  accountingSettings: 'regnskap/innstillinger',
  accountingFinalizePeriod: 'regnskap/bli-ferdig',
  tripletex: 'regnskap/tripletex',
  tripletexSetup: 'regnskap/tripletex/koble-til',
  tripletexManual: 'regnskap/tripletex/manuelt',
  fiken: 'regnskap/fiken',
  fikenSetup: 'regnskap/fiken/koble-til',
  fikenManual: 'regnskap/fiken/manuelt',
  fikenDirect: 'regnskap/fiken-direkte',
  fikenDirectDisconnect: 'regnskap/fiken-direkte/skru-av',
  powerOfficeGo: 'regnskap/poweroffice-go',
  powerOfficeGoSetup: 'regnskap/poweroffice-go/koble-til',
  powerOfficeGoManual: 'regnskap/poweroffice-go/manuelt',
  unimicro: 'regnskap/unimicro',
  unimicroSetup: 'regnskap/unimicro/koble-til',
  unimicroManual: 'regnskap/unimicro/manuelt',
  vismaEAccounting: 'regnskap/visma-eaccounting',
  vismaEAccountingSetup: 'regnskap/visma-eaccounting/koble-til',
  vismaEAccountingManual: 'regnskap/visma-eaccounting/manuelt',
  tfso: 'regnskap/24sevenoffice',
  tfsoSetup: 'regnskap/24sevenoffice/koble-til',
  tfsoManual: 'regnskap/24sevenoffice/manuelt',
  accountingSystemSelector: 'regnskap/velg-regnskapssystem',
  singleTransaction: 'bevegelser/:fid',
  profile: 'profil',
  orgSettings: 'innstillinger',
  orgSubscriptionInfo: 'innstillinger/abonnement',
  orgSubscriptionPreliminaryInvoice: 'innstillinger/abonnement/faktura',
  orgSubscriptionInvoice: 'innstillinger/abonnement/faktura/:fid',
  orderTaxAccount: 'bestill-skattetrekkskonto',
  taxAccountReady: 'skattetrekkskonto-klar',
  orderSavingsAccount: 'bestill-sparekonto',
  savingsAccountReady: 'sparekonto-klar',
  customerService: 'kundeservice',
  moveMoneyFromSavingsAccount: 'overfor-fra-sparekonto',
  moveMoneyToSavingsAccount: 'overfor-til-sparekonto',
  earmarks: 'sparekonto',
  transferFromEarmark: 'sparekonto/overfor-fra/:fid',
  transferToEarmark: 'sparekonto/overfor-til/:fid'
};
export const bankPagesPrefix = '/org/:org';
const oAuthPages = {
  oauthConsent: 'godkjenn-tilkobling',
  oauthError: 'feil-med-tilkobling'
};
export const pages = {
  ...loginPages,
  ...bankPages,
  ...oAuthPages,
  notFound: 'notfound'
};
const onboardingGenericPages = {
  start: '/',
  auth: 'bankid',
  selectOrg: 'velg-organisasjon',
  noSigningRights: 'ikke-signaturrett',
  outOfOperation: 'ute-av-drift',
  alreadyOrdered: 'allerede-bestilt'
};
const onboardingDeepPages = {
  person: 'om-deg',
  company: 'om-selskapet',
  tax: 'betalinger',
  ownership: 'eierskap',
  enkPerson: 'om-deg',
  enkCompany: 'bedriften',
  enkFinance: 'okonomi',
  enkSigning: 'signering',
  signing: 'signering',
  submit: 'send-inn',
  rejectedOrg: 'beklager',
  partiallyOnboarded: 'ikke-ferdig-bestilt',
  alreadySpvEnkCustomer: 'allerede-spv-kunde'
};
export const onboardingPagesPrefix = '/bli-kunde';
export const onboardingDeepPagesPrefix = '/:orgNum';
export const updateInfoPrefix = '/oppdater-info';
export const onboardingPages = {
  ...onboardingGenericPages,
  ...onboardingDeepPages,
  notFound: 'notfound'
};
const foundingOnboardingGenericPages = {
  start: '/',
  contactSupport: 'kontakt',
  order: 'bestill',
  continueFallback: 'fortsett'
};
const foundingOnboardingDeepPages = {
  finances: 'okonomi',
  payments: 'betalinger',
  owners: 'om-eierne',
  signing: 'signering',
  submitted: 'innsendt',
  partiallyOnboarded: 'ikke-ferdig-bestilt'
};
export const foundingOnboardingPages = {
  ...foundingOnboardingGenericPages,
  ...foundingOnboardingDeepPages
};
export const foundingOnboardingPagesPrefix = '/stiftelse';
export const foundingOnboardingDeepPagesPrefix = '/:orgId';
export const accountingIntegrationErrorPages = {
  start: '/feil-med-regnskapstilkobling'
};
export const accountantInvitationPages = {
  root: ':invitationKey',
  accept: ':invitationKey/godta'
};
export const accountantInvitationPagesPrefix = '/regnskapsforer';
export const backofficePages = {
  root: '/',
  search: 'sok',
  broadcast: 'broadcast',
  newBroadcast: 'ny',
  editBroadcast: ':broadcastId',
  org: 'org/:orgNum',
  subscription: 'abonnement',
  subscriptionPaymentHistory: 'abonnement/historikk',
  preliminaryInvoice: 'abonnement/historikk/forelopig-faktura',
  invoice: 'abonnement/historikk/faktura/:fid',
  agent: 'agenter/:fid',
  earmarks: 'oremerking',
  kyc: 'kyc'
};
export const backofficePrefix = '/backoffice';
//# sourceMappingURL=pages.js.map